import { Span } from '@tblabs/truffle';
import { Translations } from '../../Translations/Translations';
import { PrimaryButton } from '../General/Buttons/PrimaryButton';
import { Screen } from '../Screens/Screen';


export class KickedScreen extends Screen
{
    constructor(_lang: Translations, reason: string)
    {
        super(
            new Span("❌ " + _lang.Problem).Class("launching-label"),
            "\n" + reason + "\n\n\n",
            new PrimaryButton(_lang.LoginAgain)
                .OnClick(() => window.location.hash = "login")
        );
    }
}
